//function that takes multiple params and replace {{placeholder}} with parameters as per the position.
//translatedStrng={{remaining}} of {{total}} Available , params=[15,15]
export const translateWithPlaceholders = (translatedStrng: string, ...params: any[]) => {
  if (!translatedStrng || !params || params.length === 0) {
    return translatedStrng;
  }
  const regex = /{{\w+}}/g;
  const matches = [...translatedStrng.matchAll(regex)];
  let result = translatedStrng;
  matches.forEach((match, index) => {
    result = result.replace(match[0], params[index]);
  });
  return result;
};
